<template>
	<div class="keywordList">
		<div class="module-item-style mgt10">
			<div class="filter-wrapper">
				<div class="filter-wrapper-item" v-if="false">
					<el-radio-group size="small" v-model="activeName" @change="handleTabClick">
						<el-radio-button label="today" name="">今天</el-radio-button>
						<el-radio-button label="yesterday" name="">昨天</el-radio-button>
						<el-radio-button label="weekday" name="">最近7天</el-radio-button>
						<el-radio-button label="30day" name="">最近30天</el-radio-button>
						<el-radio-button label="month" name="">本月</el-radio-button>
					</el-radio-group>
				</div>
				<div class="filter-wrapper-item">
					<el-date-picker
						size="small"
						v-model="selectTime"
						type="daterange"
						@change="timeSelect"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format="yyyy-MM-dd"
						value-format="timestamp"
						:picker-options="pickerOptions"
					>
					</el-date-picker>
				</div>
				<div class="filter-wrapper-item">
					<el-input
						size="small"
						placeholder="关键词模糊搜索" v-model="searchInfo.likeWord" class="input-with-select">
						<el-button @click="searchList" slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div>
			</div>
		</div>
		<div class="module-item-style mgt10">
			<div class="table-border">
				<el-table
						size="small"
						v-loading="isLoading"
						stripe
						:data="tableData"
						:header-cell-style="{ background:'#f2f2f2' }">
					<el-table-column
							label="关键词">
						<template slot-scope="scope">
							{{ scope.row.trackKeyword }}
						</template>
					</el-table-column>
					<el-table-column
							label="访客数">
						<template slot-scope="scope">
							{{ scope.row.visitorNum }}
						</template>
					</el-table-column>
					<el-table-column
							label="浏览次数">
						<template slot-scope="scope">
							{{ scope.row.visitorNum }}
						</template>
					</el-table-column>
					<el-table-column
							label="请求对话">
						<template slot-scope="scope">
							{{ scope.row.requestCallingNum }}
						</template>
					</el-table-column>
					<el-table-column
							label="邀请对话">
						<template slot-scope="scope">
							{{ scope.row.successCallingNum }}
						</template>
					</el-table-column>
					<!--<el-table-column
							label="成功对话">
						<template slot-scope="scope">
							{{ scope.row.successCallingNum }}
						</template>
					</el-table-column>
					<el-table-column
							label="点击率">
						<template slot-scope="scope">
							{{ scope.row.requestCallingNum }}
						</template>
					</el-table-column>-->
				</el-table>
			</div>
			<div class="pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="searchInfo.pageNum"
					:page-size="10"
					layout="total, prev, pager, next, jumper"
					:total="pageTotal">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
  import { keywordStatisticList } from '@/api/modules/report/website'
  export default {
    name: 'index',
    data() {
      return {
        isLoading: false,
        tableData: [],
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
					}
				},
        pageTotal: 0,
        activeName: '',
        searchInfo: {
          likeWord: '',
          pageNum: 1,
          startTime: '',
          endTime: ''
        },
        selectTime: ''
      }
    },
    methods: {
      // 点击tab搜索
      handleTabClick() {
        const activeName = this.activeName
        console.log(activeName)
      },
      /**
       * 时间选择
       */
      timeSelect() {
        if (this.selectTime) {
          this.searchInfo.startTime = this.selectTime[0] / 1000
					let endTime = this.selectTime[1] / 1000
					this.searchInfo.endTime = endTime + 24 * 60 * 60 - 1
        } else {
          this.searchInfo.startTime = ''
          this.searchInfo.endTime = ''
        }

        this.$nextTick(() => {
          this.searchList()
        })
      },
      searchList() {
        this.keywordStatisticListFn()
      },
      // 关键词列表
      keywordStatisticListFn() {
        const param = this.searchInfo
        this.$http.keywordStatisticList(param).then(res => {
          if (res.status == 1) {
            this.tableData = res.data.data
            this.pageTotal = res.data.total
          }

        })
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.searchInfo.pageNum = val
        this.searchList()
        // console.log(`当前页: ${val}`);
      }
    },
    created() {
      this.searchList()
    }
  }
</script>

<style scoped lang="scss">
	.keywordList{

	}
</style>
